import { Component, inject, input } from '@angular/core';
import { SpinnerService } from './services/spinner.service';
import { AsyncPipe } from '@angular/common';
import { SpinnerType } from './spinner.type';

@Component({
  standalone: true,
  imports: [AsyncPipe],
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  private _spinnerService = inject(SpinnerService);
  spinnerType = input.required<SpinnerType>();
  isLoading$ = this._spinnerService.isLoading$;
  isLoadingUserData$ = this._spinnerService.isLoadingUserData$;
}
